import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBodyBold2 } from '../common/Text'
import Link from '../common/Link'

export type FooterNavProps = BoxProps & {}

const FooterNav: React.FC<FooterNavProps> = ({ ...others }) => {
  return (
    <Box {...others}>
      <Box>
        <Link to="/">
          <TextBodyBold2 localizeKey="nav__global__top_alt" as="span" />
        </Link>
      </Box>
      <Box>
        <Link to="/artists/">
          <TextBodyBold2 localizeKey="nav__global__artists" as="span" />
        </Link>
      </Box>
      <Box>
        <Link to="/event/">
          <TextBodyBold2 localizeKey="nav__global__event" as="span" />
        </Link>
      </Box>
      <Box>
        <Link to="/ticket/">
          <TextBodyBold2 localizeKey="nav__global__ticket" as="span" />
        </Link>
      </Box>
      <Box>
        <Link to="/about/">
          <TextBodyBold2 localizeKey="nav__global__about" as="span" />
        </Link>
      </Box>
      <Box>
        <Link to="/access/">
          <TextBodyBold2 localizeKey="nav__global__access" as="span" />
        </Link>
      </Box>
    </Box>
  )
}

export default FooterNav
